// Настройки по умолчанию для редактора
export const defaultSettings = {
  plugins: 'link,code,lists',
  toolbar: [
    `styleselect | fontsizeselect bold italic underline | bullist numlist outdent indent blockquote | undo redo
    | link | alignleft aligncenter alignright alignjustify | code`,
  ],
}
